import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { environment } from '../../environments/environment';
import {Router, NavigationStart, ActivatedRoute} from '@angular/router';
import { LdsUserService } from '../lib/services/lds-user.service';
import { filter } from 'rxjs/operators';
import { WsChatService } from '../lib/lds-websocket-module/ws-chat/ws-chat.service';
import { WsPacketService } from '../lib/lds-websocket-module/ws-packet/ws-packet.service';
interface WebSocketPacket {
	direction: string;
	items: any[];
	senderId: string | number;
	transactionId: number;
	class: string;
	operation: string;
	version: number;
}
@Component({
    selector: 'ds-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  clicks = 0;

	message: string;
	loading: boolean;
	mfaRequired = false;
	mfaCode = '';
	isPlusError = false;

	user = {
		username: '',
		password: '',
		action: () => {
			if (this.user.password === '') {
        // TODO: set error message for no password
        this.message = 'No Password';
			} else {
				this.performLogin();
			}
		}

	};

	performLogin(): void {
		const mfaCodeToSend = this.mfaRequired ? this.mfaCode : undefined;

		this.authService.login(this.user.username, this.user.password, mfaCodeToSend).subscribe((resp) => {
			this.mfaRequired = false;
			this.mfaCode = '';
			this.message = '';
			this.isPlusError = false;
			this.authService.saveUserDetail(resp);
			this.initiateWs(resp);
			this.wsChatService._checkAuth()
				.then(() => {
					let wsPacket = this.wsPacketService.getPacket('user', 'read', {});
					this.wsChatService._sendMsg(wsPacket)
						.then((userSettings: WebSocketPacket) => {
							const settings = userSettings.items[0].payload;
							const license = settings.licenses && settings.licenses.v5.license;
							if (!license) {
								this.message = 'My Lightwave Energy Dashboard is available exclusively to Lightwave PLUS members.';
								this.isPlusError = true;
								this.wsChatService.close();
								return;
							}
							this.authService.isLoggedIn = true;
							this.ldsUser.userDetail = resp;
							this.router.navigate(['/data-studio/energy/overview'], {relativeTo: this.route});
						});
				});
		},
		err => {
			this.isPlusError = false;
			if (err.status === 401 && err.error?.error === 'mfa_required') {
				this.mfaRequired = true;
				this.mfaCode = '';
				this.message = 'Please enter your 6-digit authentication code';
			} else if (err.status === 401 && this.mfaRequired) {
				this.message = 'Invalid authentication code. Please try again.';
				this.mfaCode = '';
			} else {
				this.message = 'failed to login';
			}
			console.log(err);
		});
	}

	constructor(private authService: AuthService, private router: Router, private ldsUser: LdsUserService, private route: ActivatedRoute, private wsChatService: WsChatService, private wsPacketService: WsPacketService) {

	}

	setMessage(): void {
		this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
	}

	ngOnInit() {
		this.router.events.pipe(filter((d) => d instanceof NavigationStart)).subscribe((event) => {
			this.loading = true;
		});
    const url = this.router.url.split('?');
    if (url[0] === '/demo') {
      this.loadDemo();
    }
	}

  initiateWs(usrInfo) {
    if (this.wsChatService.alreadyAuthed()) {
        this.wsChatService.initiateNoAuth(usrInfo.user._id);
    } else {
        this.wsChatService.initiate(usrInfo.user._id);
    }
  }

  loadDemo() {
    const demoUser = {
        "user": {
          "givenName": "Demo",
          "familyName": "Account",
          "email": "demo@account.com",
          "lightwaveRfPublic": {
            "country": "United Kingdom",
          },
          "providers": {},
          "_id": "",
          "created": 0,
          "modified": 0
        },
        "tokens": {
          "access_token": "",
          "token_type": "",
          "expires_in": 0,
          "refresh_token": "",
          "id_token": "",
        }
      }
    this.authService.isLoggedIn = true;
    this.ldsUser.userDetail = demoUser;
    this.router.navigate(['/data-studio/energy/overview'], { queryParams: { demo: 'true' } });
  }

  loginAs(){
    this.clicks++;

    if(this.clicks >= 5){
      this.clicks = 0;
      this.router.navigate(['/ybtvanf']);
    }
  }

}
